import { render, staticRenderFns } from "./AdditionalAddressData.vue?vue&type=template&id=0787b180&scoped=true"
import script from "./AdditionalAddressData.vue?vue&type=script&lang=js"
export * from "./AdditionalAddressData.vue?vue&type=script&lang=js"
import style0 from "./AdditionalAddressData.vue?vue&type=style&index=0&id=0787b180&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0787b180",
  null
  
)

export default component.exports